import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { CSVLink } from 'react-csv';
import moment from 'moment-timezone';

export default function List() {
    const navigate = useNavigate();

    const [countRecords, setCountRecords] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [totalRegisteredCount, setTotalRegisteredCount] = useState(0);
    const [totalProfileCount, setTotalProfileCount] = useState(0);
    const [startDate, setStartDate] = useState(moment().tz("Asia/Kolkata").subtract(30, 'days').format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment().tz("Asia/Kolkata").format("YYYY-MM-DD"))

    const getCountRecords = async () => {
        const res = await axios.get(`${API_URL}/candidate/reports/registered-candidates-count?startDate=${startDate}&endDate=${endDate}`);
        if(res.data.statusCode == 200){
            setCountRecords(res.data.result.usersCount);
            setTotalRegisteredCount(res.data.result.totalKeycloakUserCount);
            setTotalProfileCount(res.data.result.totalClpUserCount);
    
            let csvData = res.data.result.usersCount;
            csvData = csvData.map( (obj) => {
                obj.registeredDate = moment(obj.registeredDate).format('DD-MMM-YY')
                return obj;
            })
            csvData.unshift({registeredDate:'Date',keycloakRecordsCount:'Registered Candidate',clpRecordsCount:'Profile Created'})
            setCsvData(csvData)
        }
    }

    const csvHeaders = [
        { label: 'Total', key: 'registeredDate' },
        { label: totalRegisteredCount, key: 'keycloakRecordsCount' },
        { label: totalProfileCount, key: 'clpRecordsCount' },
    ];

    useEffect( () => {
        getCountRecords()
    },[])

    return (
        <div className="list-component-main-div">
            <div className="home-menu-main-div component-heading-main-div">
                <div className="list-heading-div">
                    <div className="list-title">REGISTERED CANDIDATES REPORT</div>
                    <div className="list-title-line" />
                </div>
                <div className="home-menu-btn align-items-center">
                    <div className="home-menu-btn add-btn-div-cls">
                    <CSVLink data={csvData} headers={csvHeaders} filename='output.csv'>Export</CSVLink>
                    {/* <Button className="menu-btn-cls" onClick={() => navigate('/add-user')}>Export</Button> */}
                    </div>
                    <div className="back-btn-div-cls">
                        <Button className="back-btn-cls" onClick={() => navigate('/home')}><MdOutlineArrowBack /> BACK</Button>
                    </div>
                </div>
            </div>
            <Container className="mb-4">
                <Row>
                    <Col>
                    <label>Start Date:</label>
                    <Form.Control type="date"
                        defaultValue={startDate}
                        onChange={ (e) => setStartDate(e.target.value) }/>
                    </Col>
                    <Col>
                    <label>End Date:</label>
                    <Form.Control type="date" 
                        defaultValue={endDate}
                        onChange={ (e) => setEndDate(e.target.value) }/>
                    </Col>
                    <Col>
                    <label style={{"visibility": "hidden"}}>Submit</label><br/>
                    <Button className="menu-btn-cls" onClick={ () => getCountRecords() }>Submit</Button>
                    </Col>
                </Row>
            </Container>
            
            
            <Table responsive className="list-table-cls">
                <thead className="list-thead-cls">
                    <tr className="list-thead-tr">
                        <th>Total</th>
                        <th>{totalRegisteredCount}</th>
                        <th>{totalProfileCount}</th>
                    </tr>
                    <tr className="list-thead-tr">
                        <th>Date</th>
                        <th>Registered Candidates</th>
                        <th>Profile Created</th>
                    </tr>
                </thead>
                <tbody>
                    { countRecords.map( (record, index) => (
                        <tr key={index}>
                            <td style={{borderRight: '1px solid black'}}>{record.registeredDate}</td>
                            <td style={{borderRight: '1px solid black'}}>{record.keycloakRecordsCount}</td>
                            <td>{record.clpRecordsCount}</td>
                        </tr>
                    ) )}
                </tbody> 
            </Table>
        </div>
    )
}